module.exports = __webpack_public_path__ + "static/media/blueclock.e1b28c36.svg";